import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminRoutes from "./admin/adminRoutes";
import PublicRoutes from "./public/publicRoutes";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/*" element={<AdminRoutes />} />
        <Route path="/*" element={<PublicRoutes />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
